<template>
  <div class="page-content" id="allOffersPage">
    <Titlebar :backPath="'/home'">
      <h1>{{ $t("nav.offers") }}</h1>
    </Titlebar>

    <div class="row ">
      <div class="col">
        <!-- OFFRE STANDARD-->
        <UiCard class="card-item">
          <div class="card-item-top">
            <span class="pictoBtn" v-html="pictoStandard"></span>
            <div class="title-wrapper">
              <h2 class="title-min">{{ $t("offers.offer") }}</h2>
              <h2 class="colored-title">Standard</h2>
            </div>
          </div>
          <div class="card-item-section">
            <div class="card-item-section__heading">
              <img :src="require('@/assets/img/offers/iPhoneXR_2@2x.png')" alt="application beepiz">
              <div>
                <p>{{ $t("offers.subtitle1") }}</p>
                <p class="colored-sentence">{{ $t("offers.app") }}</p>
              </div>
            </div>
            <div class="card-item-section__content">
              <p class="section-content__title">{{ $t("offers.standard.p1") }}</p>
              <div class="card-item-section__content-list">
                <p>{{ $t("offers.standard.p2") }}</p>
                <p>{{ $t("offers.standard.p3") }}</p>
                <p>{{ $t("offers.standard.p4") }} <span>{{ $t("offers.standard.s4") }}</span></p>
              </div>
            </div>
          </div>
          <div class="card-item-section">
            <div class="card-item-section__heading">
              <img :src="require('@/assets/img/offers/Mockup navigateur Beepiz.png')" alt="navigateur beepiz">
              <div>
                <p>{{ $t("offers.subtitle2") }}</p>
                <p class="colored-sentence">{{ $t("offers.web") }}</p>
              </div>
            </div>
            <div class="card-item-section__content">
              <p class="section-content__title">{{ $t("offers.standard.p5") }}</p>
              <div class="card-item-section__content-list">
                <p>{{ $t("offers.standard.p6") }}</p>
                <p>{{ $t("offers.standard.p7") }}</p>
                <p>{{ $t("offers.standard.p8") }}</p>
                <p>{{ $t("offers.standard.p9") }}</p>
                <p>{{ $t("offers.standard.p10") }} <span>{{ $t("offers.standard.s10") }}</span></p>
              </div>
            </div>
          </div>
          <div class="card-item__price">
            <p>{{ $t("offers.from") }} <span>5,99€</span></p>
            <a href="https://share.hsforms.com/1T6dV1wNfRJ2B_oHU9jKMFw56ack" target="_blank">{{ $t("offers.interested") }}</a>
          </div>
        </UiCard>
      </div>
      <div class="col">
        <!-- OFFRE PREMIUM-->
        <UiCard class="card-item">
          <div class="card-item-top">
            <span class="pictoBtn" v-html="pictoPremium"></span>
            <div class="title-wrapper">
              <h2 class="title-min">{{ $t("offers.offer") }}</h2>
              <h2 class="colored-title">Premium</h2>
            </div>
          </div>

          <div class="offer-row offer-row">
            <span class="pictoBtnRow" v-html="pictoStandard"></span>
            <div class="offer-row-content">
              <p>{{ $t("offers.fonctionnality") }}</p>
              <p class="offer-row-content__colored">{{ $t("offers.standard.title") }}</p>
            </div>
          </div>

          <div class="plus-row">
            +
          </div>

          <div class="card-item-section">
            <div class="card-item-section__heading">
              <img :src="require('@/assets/img/offers/iPhoneXR_2@2x.png')" alt="application beepiz">
              <div>
                <p>{{ $t("offers.subtitle1") }}</p>
                <p class="colored-sentence">{{ $t("offers.app") }}</p>
              </div>
            </div>
            <div class="card-item-section__content">
              <p class="section-content__title">{{ $t("offers.premium.p1") }}</p>
              <div class="card-item-section__content-list">
                <p>{{ $t("offers.premium.p2") }}
                  <span>{{ $t("offers.premium.s2") }}</span>
                </p>
                <p>{{ $t("offers.premium.p3") }}</p>
                <p>{{ $t("offers.premium.p4") }}
                  <span>{{ $t("offers.premium.s4") }}</span>
                </p>
                <p>{{ $t("offers.premium.p5") }}</p>
                <p>{{ $t("offers.premium.p6") }}</p>
                <p>{{ $t("offers.premium.p11") }}</p>
              </div>
            </div>
          </div>
          <div class="card-item-section">
            <div class="card-item-section__heading">
              <img :src="require('@/assets/img/offers/Mockup navigateur Beepiz.png')" alt="navigateur beepiz">
              <div>
                <p>{{ $t("offers.subtitle2") }}</p>
                <p class="colored-sentence">{{ $t("offers.web") }}</p>
              </div>
            </div>
            <div class="card-item-section__content">
              <p class="section-content__title">{{ $t("offers.premium.p7") }}</p>
              <div class="card-item-section__content-list">
                <p>{{ $t("offers.premium.p8") }}</p>
                <p>{{ $t("offers.premium.p9") }}</p>
                <p>{{ $t("offers.premium.p10") }}</p>
              </div>
            </div>
          </div>
          <div class="card-item__price">
            <p>{{ $t("offers.from") }} <span>8,99€</span></p>
            <a href="https://share.hsforms.com/1Hd-hL75OSbG-mg4nfQF_hg56ack" target="_blank">{{ $t("offers.interested") }}</a>
          </div>
        </UiCard>
      </div>
      <div class="col">
        <!-- OFFRE ENTERPRISE-->
        <UiCard class="card-item">
          <div class="card-item-top">
            <span class="pictoBtn" v-html="pictoEnterprise"></span>
            <div class="title-wrapper">
              <h2 class="title-min">{{ $t("offers.offer") }}</h2>
              <h2 class="colored-title">Enterprise</h2>
            </div>
          </div>

          <div class="offer-row offer-row-first">
            <span class="pictoBtnRow" v-html="pictoStandard"></span>
            <div class="offer-row-content">
              <p>{{ $t("offers.fonctionnality") }}</p>
              <p class="offer-row-content__colored">{{ $t("offers.standard.title") }}</p>
            </div>
          </div>

          <div class="offer-row">
            <span class="pictoBtnRow" v-html="pictoPremium"></span>
            <div class="offer-row-content">
              <p>{{ $t("offers.fonctionnality") }}</p>
              <p class="offer-row-content__colored">{{ $t("offers.premium.title") }}</p>
            </div>
          </div>

          <div class="plus-row">
            +
          </div>

          <div class="card-item-section">
            <div class="card-item-section__heading">
              <img :src="require('@/assets/img/offers/Mockup navigateur Beepiz.png')" alt="navigateur beepiz">
              <div>
                <p>{{ $t("offers.subtitle2") }}</p>
                <p class="colored-sentence">{{ $t("offers.web") }}</p>
              </div>
            </div>
            <div class="card-item-section__content">
              <p class="section-content__title">{{ $t("offers.enterprise.p1") }}</p>
              <div class="card-item-section__content-list">
                <p>{{ $t("offers.enterprise.p2") }}</p>
                <p>{{ $t("offers.enterprise.soon") }}</p>
              </div>
            </div>
          </div>
          <div class="card-item__price">
            <p>{{ $t("offers.from") }} <span>13,99€</span></p>
            <a href="https://share.hsforms.com/1IMcu3u-8Sm6CZtdv9EKpMA56ack" target="_blank">{{ $t("offers.interested") }}</a>
          </div>
        </UiCard>
      </div>
      <div class="col col mt-5">

        <UiCard class="card-item prospection card-item__price">
          <h4>{{ $t("offers.prospect.p1") }}</h4>
          <h4>{{ $t("offers.prospect.p2") }}</h4>
          <h4>{{ $t("offers.prospect.p3") }}</h4>
          <h5>{{ $t("offers.prospect.p4") }}</h5>
          <a href="https://share.hsforms.com/1_3U7ksu8TKSdh36zAzRo2A56ack" target="_blank" class="">{{ $t("offers.prospect.p5") }}</a>
        </UiCard>
      </div>
    </div>
  </div>
</template>

<script>
import Titlebar from "@/components/ui/Titlebar";
import UiCard from "@/components/ui/Card";

import picto_standard from '@/assets/img/picto/1_Standard_yellow.svg'
import picto_premium from '@/assets/img/picto/2_Premium_yellow.svg'
import picto_enterprise from '@/assets/img/picto/3_Enterprise_yellow.svg'

export default {
  name: "Offers",
  components: {
    Titlebar,
    UiCard,
  },
  computed: {
    pictoStandard() {
      return picto_standard
    },
    pictoPremium() {
      return picto_premium
    },
    pictoEnterprise() {
      return picto_enterprise
    },
  },
  mounted() {
    window.Vfc.$refs.loading.hide();
  },
};
</script>

<style lang="scss" scoped>


#allOffersPage{

  .pictoBtn{
    width: 36px;
    height: 36px;
    display: block;
    margin-right: 12px;
  }
  .pictoBtnRow{
    width: 30px;
    height: 30px;
    display: block;
    margin-right: 10px;
  }
  .container{
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .card-item{
    flex: 1;
    text-align: center;
    padding: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    border-radius: 20px;
    position: relative;
    overflow-y: auto;
    -ms-overflow-style: none;  /* display none for the scrollbar IE and Edge */
    scrollbar-width: none;  /* Firefox */
    &-top{
      display: flex;
      flex-wrap: wrap;
      width:100%;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
    }
    img{
      width: 70px;
      height: 60px;
      object-fit: contain;
      display: block;
      margin-right: 10px;
    }
    .title-wrapper{
      .title-min{
        margin: 0;
        font-size: 1.5rem;
        text-align: left;
      }
      .colored-title{
        margin: 0;
        color:#ffc107;
        text-transform: uppercase;
        font-weight: 600;
      }
    }
    &-section{
      width: 100%;
      margin-bottom: 15px;
      &__heading{
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        p{
          text-align: left;
          font-size: 1.3rem;
          font-weight: 500;
          margin: 0;
        }
        .colored-sentence{
          color:var(--colors-gray-500);
        }
      }
      &__content{
        text-align: left;
        &-list{
          span{
            font-style: italic;
          }
        }
        p{
          font-weight: 500;
          margin-bottom: .5rem;
        }
      }
    }
    .section-content__title{
    }
    &__price{
      align-self: flex-end;
      border-radius: 10px;
      color: black;
      width: 100%;
      font-weight: 500;
      p{
        font-size: 1.1rem;
        margin: 0 0 2px 0;
        color: var(--colors-gray-500);
        span{
          font-weight: 600;
        }
      }
      a{
        background: #ffc107;
        color: black;
        display: inline-block;
        width: 80%;
        padding: 5px;
        font-size: 1.2rem;
        border: none;
        border-radius: 10px;
        text-decoration: none;
      }
    }
    .banner{
      width: 100%;
      background: #ffc107;
      color: black;
      font-weight: 700;
      text-align: center;
      font-size: 1.3rem;
      padding: 8px 0;
      font-style: italic;
      position: absolute;
      top: 100px;
    }

    .offer-row{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      width: 100%;
      &.offer-row-first{
        padding-top: 50px;
      }
      .offer-row-content{
        text-align: left;
        p{
          margin: 0;
          font-size: 1rem;
          font-weight: 500;
        }
        &__colored{
          color: #ffc107;
          text-transform: uppercase;
          font-weight: 600!important;
        }
      }
    }

    .plus-row{
      text-align: center;
      width: 100%;
      margin-bottom: 10px;
      font-size: 2rem;
    }

    &.prospection{
      background: transparent;
      color: black;
      display: block;
      padding-top: 15%;
      h5{
        margin: 30px 0;
      }
    }
    .prospection-btn{
      display: inline-block;
      padding: 10px 12px;
      border-radius: 10px;
      background: #ffc107;
      color: black;
      border: none;
      text-decoration: none;
      font-size: 1.25rem;
      font-weight:500;
      font-family: inherit;
      cursor: pointer;
      transition: all 0.3s ease;
      &:hover{
        color: #ffc107;
        background: #212121;
      }
    }
  }
}

@media screen and (min-width: 1600px){
  #allOffersPage{
    .card-item{
      height: calc(100% - 80px);
      &-section{
        &__heading{
          margin-bottom: 20px;
          p{
            font-size: 1.5rem;
          }
        }
        &__content{
          &-list{
            span{
              font-size: 0.8rem;
              font-style: italic;
            }
          }
          p{
            font-weight: 500;
            font-size: 1.2rem;
            margin-bottom: 1rem;
          }
        }
      }
      .section-content__title{
        font-size: 1.2rem;
      }
      &__price{
        p{
          font-size: 1.3rem;
          margin: 0 0 8px 0;
        }
        a{
          padding: 8px;
          font-size: 1.3rem;
        }
      }
      .offer-row{
        &.offer-row-first{
          padding-top: 60px;
        }
        .offer-row-content{
          p{
            font-size: 1.5rem;
          }
        }
      }
      .plus-row{
        font-size: 2.5rem;
      }
    }
  }

}

@media screen and (max-width: 1330px) {
  #allOffersPage .card-item .banner{
    top: 140px;
  }
}
</style>
